export default "__VITE_ASSET__15389b40__"